export default __webpack_public_path__ + "static/media/vintage100-2.f322adee.jpg";